import Crypto from "crypto-js";
import { SESSION_SECRET } from "../config/env";

/**
 * Ofusca / desofusca la sesión que se guarda en la cookie del navegador.
 *
 * OJO: esto NO es seguridad. La frase de cifrado viaja en el bundle, así que
 * cualquiera puede descifrar la cookie. Sólo evita que el access_token quede
 * legible a simple vista en las devtools. Toda la autorización real (roles,
 * permisos, ownership) tiene que validarse en el backend en cada request.
 */
const auth = {
  encode(token) {
    return Crypto.AES.encrypt(JSON.stringify(token), SESSION_SECRET).toString();
  },
  decode(token) {
    if (!token) return null;

    try {
      const decoded = Crypto.AES.decrypt(token, SESSION_SECRET).toString(
        Crypto.enc.Utf8
      );
      return decoded ? JSON.parse(decoded) : null;
    } catch (error) {
      // Cookie de una sesión anterior (otra frase de cifrado) o corrupta:
      // se trata como "sin sesión" en lugar de tirar la app.
      return null;
    }
  },
};

export default auth;
